import parse from 'html-react-parser';
import React, { memo, useState } from 'react';
import { Button, Col, Form, Row } from 'react-bootstrap';
import angelEvaluation from '../../../assets/images/angelEvaluation.png';
import ocularMotility from '../../../assets/images/ocularMotility.png';
import CommonButtons from './commonButtons';

const OcularExamination = ({
  selectedOnExamination,
  handleOnExaminationData,
}) => {
  const crossIcon = '<i className="fa fa-times-circle"></i>';
  const checkedIcon = '<i className="fas fa-check-circle"></i>';
  let { ocularExamination } = selectedOnExamination;
  ocularExamination = ocularExamination || {

    visualAcuity: {
      val: '',
      var: '',
    },
    pl: {
      present: false,
      absent: false,
    },
    fc: '',
    hm: {
      present: false,
      absent: false,
    },
    dr: {
      present: false,
      absent: false,
    },
    medicine : {
       tablet : false,
       insulin : false,
       note : '',
    },  
    colorVision: {
      normal: false,
      deficit: false,
      red: false,
      blue: false,
      green: false,
    },
    pr: {
      first: false,
      second: false,
      third: false,
      fourth: false,
    },
    ocularMotility: {
      od: {
        first: false,
        second: false,
        third: false,
        fourth: false,
        fifth: false,
        sixth: false,
      },
      os: {
        first: false,
        second: false,
        third: false,
        fourth: false,
        fifth: false,
        sixth: false,
      },
    },
    angleEvaluationBefore: {
      od: {
        first: '',
        second: '',
        third: '',
        fourth: '',
      },
      os: {
        first: '',
        second: '',
        third: '',
        fourth: '',
      },
    },
    angleEvaluationAfter: {
      od: {
        first: '',
        second: '',
        third: '',
        fourth: '',
      },
      os: {
        first: '',
        second: '',
        third: '',
        fourth: '',
      },
    },
    iop: {
      high: '',
      low: '',
    },
    ADD:{
      add:'',  
    },
    IPD:{
      ipd:'',
    },
    RightEye: {
      sphere: '',
      cyl: '',
      axis: '',
      va: '',
    },
    LeftEye: {
      sphere: '',
      cyl: '',
      axis: '',
      va: '',
    },

  };
  const buttonArray = [
    '',
    '1/60',
    '2/60',
    '3/60',
    '4/60',
    '5/60',
    '6/6',
    '6/9',
    '6/12',
    '6/18',
    '6/24',
    '6/36',
    '6/60',
  ];

  const angleButtonArray = ['SL', 'ATM', 'PTM', 'SS', 'OH'];
  const [isValButton, setIsValButton] = useState(false);
  const [isVarButton, setIsVarButton] = useState(false);
  const [isAngleBtn, setIsAngleBtn] = useState({});

  const handleOcularExamination = (rowName, fieldName, value) => {
    if (fieldName === 'val' || fieldName === 'var') {
      ocularExamination.visualAcuity[fieldName] = value;
    } else if (rowName === 'pl') {
      ocularExamination.pl['present'] = false;
      ocularExamination.pl['absent'] = false;
      ocularExamination.pl[fieldName] = value;
    } else if (fieldName === 'fc') {
      ocularExamination[fieldName] = value;
    } else if (rowName === 'hm') {
      ocularExamination.hm['present'] = false;
      ocularExamination.hm['absent'] = false;
      ocularExamination.hm[fieldName] = value;
    } else if (rowName === 'dr') {
      ocularExamination.dr['present'] = false;
      ocularExamination.dr['absent'] = false;
      ocularExamination.dr[fieldName] = value;
    } else if (rowName === 'colorVision') {
      ocularExamination.colorVision[fieldName] = value;
    }
 
    else if (rowName === 'RightEye' || rowName === 'LeftEye') {
      ocularExamination[rowName][fieldName] = value;
      
    } else if (rowName === 'ADD') {
      ocularExamination.ADD[fieldName] = value;
    } else if (rowName === 'medicine') {
      ocularExamination.medicine[fieldName] = value;
    }
    
    setIsValButton(false);
    setIsVarButton(false);
    setIsOncularExaminatonBtn(false);
    handleOnExaminationData(ocularExamination, 'ocularExamination');
  };

  // const handleGraphicalExamination = (rowName, colName, fieldName, value) => {
  //   switch (colName) {
  //     case 'pr':
  //       ocularExamination[colName][fieldName] = value ? false : true;
  //       break;
  //     case 'od':
  //       ocularExamination[rowName][colName][fieldName] = value ? false : true;
  //       break;
  //     case 'os':
  //       ocularExamination[rowName][colName][fieldName] = value ? false : true;
  //       break;
  //   }
  //   console.log(ocularExamination, 'graphical examination');
  //   handleOnExaminationData(ocularExamination, 'ocularExamination');
  // };
  
  const [isOncularExaminatonBtn, setIsOncularExaminatonBtn] = useState(false);
  const [btnInputArray, setBtnInputArray] = useState([]);
  const [fieldName, setFieldName] = useState('');
  const [btnSign, setBtnSign] = useState('positive'); // default +

  const OncularExaminatonBtn = ({
    rowName,
    fieldName,
    btnInputArray,
    onClickAction,
  }) => {
  
    // 👉 split array into chunks of 10
    const chunkArray = (arr, size) => {
      const result = [];
      for (let i = 0; i < arr.length; i += size) { 
        result.push(arr.slice(i, i + size));
      }
      return result;
    };
  
    const rows = chunkArray(btnInputArray, 2);
  
    return (
      <div className="mt-1 unit-btn">
        {rows.map((row, rowIndex) => (
          <div key={rowIndex} className="d-flex mb-1">
            {row.map((item, index) => (
              <Button
                key={index}
                size="sm"
                className="btn-sm-customize me-1"
                variant="outline-secondary"
                onClick={() =>
                  onClickAction(rowName, fieldName, item)
                }
              >
                {item}
              </Button>
            ))}
          </div>
        ))}
      </div>
    );
  };



  const handleBtnInputArray = (field) => {
    setFieldName(field);
    let buttonArray;
    if (field === 'systolic') {
      buttonArray = [
        70, 80, 90, 100, 110, 120, 130, 140, 150, 160, 170, 180, 190, 200,
      ];
    } else if (field === 'diastolic') {
      buttonArray = [40, 50, 60, 70, 80, 90, 100, 110, 120];
    } else if (field === 'pulse') {
      buttonArray = [
        40, 45, 50, 55, 60, 65, 70, 75, 80, 85, 90, 95, 100, 105, 110, 115, 120,
      ];
    } else if (field === 'temperature') {
      buttonArray = [
        '95°',
        '96°',
        '97°',
        '98°',
        '99°',
        '100°',
        '101°',
        '102°',
        '103°',
        '104°',
        '105°',
      ];
    } else if (field === 'sphere' || field === 'sphereLeft' || field === 'cylright' || field === 'cylleft') {
      buttonArray = ["+0.25","+0.50","+0.75","+1.00","+1.25","+1.50","+1.75","+2.00",
        "+2.25","+2.50","+2.75","+3.00","+3.25","+3.50","+3.75","+4.00",
        "+4.25","+4.50","+4.75","+5.00","+5.25","+5.50","+5.75","+6.00",
        "+6.25","+6.50","+6.75","+7.00","+7.25","+7.50","+7.75","+8.00",
        "+8.25","+8.50","+8.75","+9.00","+9.25","+9.50","+9.75","+10.00"];
    } else if (field === 'sphereNeg'|| field === 'sphereLeftNeg'|| field === 'cylrightNeg' || field === 'cylleftNeg') {
      buttonArray = ["-0.25","-0.50","-0.75","-1.00","-1.25","-1.50","-1.75","-2.00",
        "-2.25","-2.50","-2.75","-3.00","-3.25","-3.50","-3.75","-4.00",
        "-4.25","-4.50","-4.75","-5.00","-5.25","-5.50","-5.75","-6.00",
        "-6.25","-6.50","-6.75","-7.00","-7.25","-7.50","-7.75","-8.00",
        "-8.25","-8.50","-8.75","-9.00","-9.25","-9.50","-9.75","-10.00"];
    } else if (field === 'axisleft' || field === 'axisright') {
      buttonArray = ["005","015","030","035","045","060","075","090","105","115","165","180"];
    } else if (field === 'varight'|| field === 'valeft') {
      buttonArray = ['6/6', '6/9', '6/12', '6/18', '6/24', '6/36', '6/60',"CF1'","CF2'","CF3'","CF4'","CF5'","HM1'","HM2'","HM3'","NPL"];
    } else if (field === 'add') {
      buttonArray = ["+1.00","+1.25","+1.50","+1.75","+2.00",
        "+2.25","+2.50","+2.75","+3.00","+3.25","+3.50"];
    }
    //setIsOncularExaminatonBtn(isOncularExaminatonBtn ? false : true);
    setIsOncularExaminatonBtn(true);
    
    setBtnInputArray(buttonArray);
  };

  const visualAcuityValButtons = buttonArray.map((item, index) => {
    return (
      <Button
        key={index}
        size="sm"
        className="btn-sm-customize"
        variant="outline-secondary"
        style={{ minWidth: '32px', padding: '0.15rem 0.25rem' }}
        onClick={() => handleOcularExamination('', 'val', item)}
      >
        {item}
      </Button>
    );
  });
  const visualAcuityVarButtons = buttonArray.map((item, index) => {
    return (
      <Button
        key={index}
        size="sm"
        className="btn-sm-customize"
        variant="outline-secondary"
        style={{ minWidth: '32px', padding: '0.15rem 0.25rem' }}
        onClick={() => handleOcularExamination('', 'var', item)}
      >
        {item}
      </Button>
    );
  });

  const handleVisualAcuityButton = (name) => {
    if (name === 'val') {
      setIsVarButton(false);
      setIsValButton(isValButton ? false : true);
    } else {
      setIsValButton(false);
      setIsVarButton(isVarButton ? false : true);
    }
  };

  const handleGraphicalExamination = (rowName, colName, fieldName, value) => {
    if (colName === 'pr') {
      ocularExamination[colName][fieldName] = value ? false : true;
    } else if (colName === 'od') {
      ocularExamination[rowName][colName][fieldName] = value ? false : true;
    } else if (colName === 'os') {
      ocularExamination[rowName][colName][fieldName] = value ? false : true;
    }
    handleOnExaminationData(ocularExamination, 'ocularExamination');
  };

  const handleAngleEvaluation = (rowName, colName, fieldName, value) => {
    setIsAngleBtn({});
    ocularExamination[rowName][colName][fieldName] = value;
    handleOnExaminationData(ocularExamination, 'ocularExamination');
  };
  const handleIop = (rowName, fieldName, value) => {
    ocularExamination[rowName][fieldName] = value;
    handleOnExaminationData(ocularExamination, 'ocularExamination');
    setIsOncularExaminatonBtn(false); 
  };

  const angleEvaluation = (rowName, type, indexName) => {
    if (isAngleBtn.rowName && isAngleBtn.type && isAngleBtn.indexName) {
      setIsAngleBtn({});
    } else {
      setIsAngleBtn({ rowName, type, indexName });
    }
  };

  return (
    <>
      <Row className="ml-0 mr-0">
        <Col md={2}>
          <b>Visual Acuity:</b>
        </Col>
        <Col>
          <Row>
            <Col>
              <Form.Group as={Row} className="mb-1">
                <Form.Label column sm="2" className="font-weight-bold pl-0">
                  VAR:
                </Form.Label>
                <Col sm="8" className="ml-2 mt-1">
                  <Button
                    size="sm"
                    className="btn-sm-customize"
                    variant="outline-secondary"
                    style={{ padding: '.15rem .5rem' }}
                    onClick={() => handleVisualAcuityButton('var')}
                  >
                    {ocularExamination.visualAcuity.var ? (
                      ocularExamination.visualAcuity.var
                    ) : (
                      <i className="fas fa-angle-double-down"></i>
                    )}
                  </Button>
                </Col>
              </Form.Group>
            </Col>
            <Col>
              <Form.Group as={Row} className="mb-1">
                <Form.Label column sm="2" className="font-weight-bold pl-0">
                  VAL:
                </Form.Label>
                <Col sm="8" className="ml-3 mt-1 pl-0 pr-0">
                  <Button
                    size="sm"
                    className="btn-sm-customize"
                    variant="outline-secondary"
                    style={{ padding: '.15rem .5rem' }}
                    onClick={() => handleVisualAcuityButton('val')}
                  >
                    {ocularExamination.visualAcuity.val ? (
                      ocularExamination.visualAcuity.val
                    ) : (
                      <i className="fas fa-angle-double-down"></i>
                    )}
                  </Button>
                </Col>
              </Form.Group>
            </Col>
          </Row>

          {isValButton && (
            <Row>
              <Col className="pb-1 mt-1 common-btn">
                {visualAcuityValButtons}
              </Col>
            </Row>
          )}
          {isVarButton && (
            <Row>
              <Col className="pb-1 ml-5 mt-1 common-btn">
                {visualAcuityVarButtons}
              </Col>
            </Row>
          )}

          <Row className={`pb-2 mt-1`}>
            <Col md="3" className="font-weight-bold">
              PL:
            </Col>
            <Col md="4">
              <Form.Check
                type={`radio`}
                id={`pl_present`}
                name="present"
                label={`Present`}
                checked={ocularExamination.pl.present === true}
                onChange={(e) =>
                  handleOcularExamination('pl', 'present', e.target.checked)
                }
              />
            </Col>
            <Col md="4">
              <Form.Check
                type={`radio`}
                id={`pl_absent`}
                name="absent"
                label={`Absent`}
                checked={ocularExamination.pl.absent == true}
                onChange={(e) =>
                  handleOcularExamination('pl', 'absent', e.target.checked)
                }
              />
            </Col>
          </Row>
          <Row className="pt-2">
            <Col md="3" className="font-weight-bold mt-1">
              FC:
            </Col>
            <Col md="7">
              <Form.Control
                type="text"
                size="sm"
                defaultValue={ocularExamination.fc}
                onChange={(e) =>
                  handleOcularExamination('', 'fc', e.target.value)
                }
              />
            </Col>
            <Col md="1 mt-1 font-weight-bold">ft</Col>
          </Row>
          <Row className="pt-3">
            <Col md="3" className="font-weight-bold">
              HM:
            </Col>
            <Col md="4">
              <Form.Check
                type={`radio`}
                id={`hm_present`}
                name="presenthm"
                label={`Present`}
                checked={ocularExamination.hm.present === true}
                onChange={(e) =>
                  handleOcularExamination('hm', 'present', e.target.checked)
                }
              />
            </Col>
            <Col md="4">
              <Form.Check
                type={`radio`}
                id={`hm_absent`}
                name="absenthm"
                label={`Absent`}
                checked={ocularExamination.hm.absent === true}
                onChange={(e) =>
                  handleOcularExamination('hm', 'absent', e.target.checked)
                }
              />
            </Col>
          </Row>
          <Row className="pt-3">
            <Col md="3" className="font-weight-bold">
              DR:
            </Col>
            <Col md="4">
              <Form.Check
                type={`radio`}
                id={`dr_present`}
                name="presentdr"
                label={`Present`}
                checked={ocularExamination?.dr?.present === true}
                onChange={(e) =>
                  handleOcularExamination('dr', 'present', e.target.checked)
                }
              />
            </Col>
            <Col md="4">
              <Form.Check
                type={`radio`}
                id={`dr_absent`}
                name="absentdr"
                label={`Absent`}
                checked={ocularExamination?.dr?.absent === true}
                onChange={(e) =>
                  handleOcularExamination('dr', 'absent', e.target.checked)
                }
              />
            </Col>
          </Row>
           <Row className="pt-3">
              <Col md="3" className="font-weight-bold">
                Medicine:
              </Col>

              <Col md="4">
                <Form.Check
                  type="checkbox"
                  id="medicine_tablet"
                  label="Tablet"
                  checked={ocularExamination?.medicine?.tablet === true}
                  onChange={(e) =>
                    handleOcularExamination('medicine', 'tablet', e.target.checked)
                  }
                />
              </Col>

              <Col md="4">
                <Form.Check
                  type="checkbox"
                  id="medicine_insulin"
                  label="Insulin"
                  checked={ocularExamination?.medicine?.insulin === true}
                  onChange={(e) =>
                    handleOcularExamination('medicine', 'insulin', e.target.checked)
                  }
                />
              </Col>
              <Col md="7" className="mt-2" style={{marginLeft: "5.5rem", textAlign: "center"}}>
              <Form.Control
                type="text"
                size="sm"
                defaultValue={ocularExamination.medicine.note}
                placeholder="Note"
                onChange={(e) =>
                  handleOcularExamination('medicine', 'note', e.target.value)
                }
              />
            </Col>
           </Row>
        </Col>
        <Col md={5} className="text-center">
          <div className="mb-3">PR:</div>
          <span
            style={{ position: 'absolute', left: '170px', top: '22px' }}
            className="mr-2 cursor-pointer"
            onClick={() =>
              handleGraphicalExamination(
                '',
                'pr',
                'first',
                ocularExamination.pr.first,
              )
            }
          >
            {ocularExamination.pr.first ? parse(checkedIcon) : parse(crossIcon)}
          </span>
          <span
            style={{ position: 'absolute', top: '57px', left: '105px' }}
            className="mr-2 cursor-pointer"
            onClick={() =>
              handleGraphicalExamination(
                '',
                'pr',
                'fourth',
                ocularExamination.pr.fourth,
              )
            }
          >
            {ocularExamination.pr.fourth
              ? parse(checkedIcon)
              : parse(crossIcon)}
          </span>
          <img src={angelEvaluation} height={60} width={90}></img>
          <span
            style={{ position: 'absolute', left: '170px', bottom: '120px' }}
            className="mr-2 cursor-pointer"
            onClick={() =>
              handleGraphicalExamination(
                '',
                'pr',
                'third',
                ocularExamination.pr.third,
              )
            }
          >
            {ocularExamination.pr.third ? parse(checkedIcon) : parse(crossIcon)}
          </span>
          <span
            style={{ position: 'absolute', top: '57px', right: '101px' }}
            className="cursor-pointer"
            onClick={() =>
              handleGraphicalExamination(
                '',
                'pr',
                'second',
                ocularExamination.pr.second,
              )
            }
          >
            {ocularExamination.pr.second
              ? parse(checkedIcon)
              : parse(crossIcon)}
          </span>
        </Col>
      </Row>

      <Row className="mt-3">
      <Col className="font-weight-bold mt-2" style={{ textAlign: "center" }}>##</Col>
        <Col className="font-weight-bold mt-2" style={{ textAlign: "center" }}>Sphere</Col>
        <Col className="font-weight-bold mt-2" style={{ textAlign: "center" }}>CYL</Col>
        <Col className="font-weight-bold mt-2" style={{ textAlign: "center" }}>Axis</Col>
        <Col className="font-weight-bold mt-2" style={{ textAlign: "center" }}>VA</Col>
      </Row>
      <Row>
      <Col className="font-weight-bold" style={{ textAlign: "center",marginTop: "0.75rem"}}>Right Eye</Col>
      <Col className="mt-2" style={{ textAlign: "center" }}>
      <Form.Control
            size="sm"
            value={ocularExamination?.RightEye?.sphere || ''}
            defaultValue={ocularExamination?.RightEye?.sphere}
            
              
            onClick={() => {
                      handleBtnInputArray('sphere');
                      setBtnSign('positive');
                      setIsOncularExaminatonBtn(isOncularExaminatonBtn ? false : true);
                    }}

            onChange={(e) => handleIop('RightEye', 'sphere', e.target.value)}
            
          />{' '}
      </Col>
      <Col className="mt-2" style={{ textAlign: "center" }}>
      <Form.Control
            size="sm"
            value={ocularExamination?.RightEye?.cyl || ' '}
            

            onClick={() => {
              handleBtnInputArray('cylright'); // use a separate key for left eye
              setBtnSign('positive');
              setIsOncularExaminatonBtn(isOncularExaminatonBtn ? false : true);
            }}

            onChange={(e) => handleIop('RightEye', 'cyl', e.target.value)}
          />{' '}
      </Col>
      <Col className="mt-2" style={{ textAlign: "center" }}>
        <Form.Control
            size="sm"
            
            value={ocularExamination?.RightEye?.axis || ' '}
            

            onClick={() => {
              handleBtnInputArray('axisright'); // use a separate key for left eye
              
              setIsOncularExaminatonBtn(isOncularExaminatonBtn ? false : true);
            }}

            onChange={(e) => handleIop('RightEye', 'axis', e.target.value)}
          />{' '}</Col>
      <Col className="mt-2" style={{ textAlign: "center" }}>
        <Form.Control
            size="sm"
            value={ocularExamination?.RightEye?.va || ' '}
            

            onClick={() => {
              handleBtnInputArray('varight'); // use a separate key for left eye
              
              setIsOncularExaminatonBtn(isOncularExaminatonBtn ? false : true);
            }}
            
            onChange={(e) => handleIop('RightEye', 'va', e.target.value)}
          />{' '}
      </Col>
      </Row>

      <Row>
      {isOncularExaminatonBtn && (fieldName === 'sphere' || fieldName === 'sphereNeg')&&(
        <Row className="justify-content-center mt-2">
          <Col md={12} className="d-flex justify-content-center flex-column align-items-center">
            <div className="mb-1"style={{marginRight: "21.25rem"}}>
                <Button
                  size="sm"
                  variant={btnSign === 'positive' ? 'primary' : 'outline-primary'}
                  className="me-2"
                  onClick={() => {
                    setBtnSign('positive');
                    handleBtnInputArray('sphere'); // positive values
                  }}
                >
                  +
                </Button>

                <Button
                  size="sm"
                  variant={btnSign === 'negative' ? 'danger' : 'outline-danger'}
                  onClick={() => {
                    setBtnSign('negative');
                    handleBtnInputArray('sphereNeg'); // negative values
                  }}
                >
                  −
                </Button>
            </div>
            <OncularExaminatonBtn
              rowName="RightEye"  
              fieldName="sphere"         
              btnInputArray={btnInputArray}
              // onClickAction={handleGeneralExamination}
              onClickAction={handleOcularExamination}
                     
            />
          </Col>
        </Row>
      )}

      {isOncularExaminatonBtn && (fieldName === 'cylright' || fieldName === 'cylrightNeg')&&(
        <Row className="justify-content-center mt-2">
          <Col md={12} className="d-flex justify-content-center flex-column align-items-center">
            <div className="mb-1">
                <Button
                  size="sm"
                  variant={btnSign === 'positive' ? 'primary' : 'outline-primary'}
                  className="me-2"
                  onClick={() => {
                    setBtnSign('positive');
                    handleBtnInputArray('cylright'); // positive values
                  }}
                >
                  +
                </Button>

                <Button
                  size="sm"
                  variant={btnSign === 'negative' ? 'danger' : 'outline-danger'}
                  onClick={() => {
                    setBtnSign('negative');
                    handleBtnInputArray('cylrightNeg'); // negative values
                  }}
                >
                  −
                </Button>
              </div>
              <OncularExaminatonBtn
                rowName="RightEye"  
                fieldName="cyl"         
                btnInputArray={btnInputArray}
                // onClickAction={handleGeneralExamination}
                onClickAction={handleOcularExamination}
                      
              />
          </Col>
        </Row>
      )}
      <Col className="mt-2" style={{ textAlign: "center" }}></Col>
      {isOncularExaminatonBtn && fieldName === 'axisright'&&(
                              <Row className="justify-content-center mt-2">
                                <Col md={3}></Col>
                                <Col md={12} className="d-flex justify-content-center flex-column align-items-center">
 
                                  <OncularExaminatonBtn
                                    rowName="RightEye"  
                                    fieldName="axis"         
                                    btnInputArray={btnInputArray}
                                    // onClickAction={handleGeneralExamination}
                                    onClickAction={handleOcularExamination}
                                          
                                  />
                                </Col>
                              </Row>
                            )}
                    {isOncularExaminatonBtn && fieldName === 'varight'&&(
                              <Row className="justify-content-end mt-2">
                                
                                <Col md={13} className="d-flex justify-content-center flex-column align-items-center">
 
                                  <OncularExaminatonBtn
                                    rowName="RightEye"  
                                    fieldName="va"         
                                    btnInputArray={btnInputArray}
                                    // onClickAction={handleGeneralExamination}
                                    onClickAction={handleOcularExamination}
                                          
                                  />
                                </Col>
                              </Row>
                            )}
      </Row>

      <Row>
        <Col className="font-weight-bold" style={{ textAlign: "center",marginTop: "1.25rem"}}>Left Eye</Col>
        <Col className="mt-3" style={{ textAlign: "center" }}>
        <Form.Control
            size="sm"
            
            value={ocularExamination?.LeftEye?.sphere || ''}
            onClick={() => {
              handleBtnInputArray('sphereLeft'); // use a separate key for left eye
              setBtnSign('positive');
              setIsOncularExaminatonBtn(isOncularExaminatonBtn ? false : true);
            }}
            
            onChange={(e) => handleIop('LeftEye', 'sphere', e.target.value)}
            />{' '}
        </Col>
        <Col className="mt-3" style={{ textAlign: "center" }}>
          <Form.Control
            size="sm"
            
            value={ocularExamination?.LeftEye?.cyl || ' '}
            

            onClick={() => {
              handleBtnInputArray('cylleft'); // use a separate key for left eye
              setBtnSign('positive');
              setIsOncularExaminatonBtn(isOncularExaminatonBtn ? false : true);
            }}
            onChange={(e) => handleIop('LeftEye', 'cyl', e.target.value)}
          />{' '}
        </Col>
        <Col className="mt-3" style={{ textAlign: "center" }}>
          <Form.Control
            size="sm"
            
            value={ocularExamination?.LeftEye?.axis || ' '}
            

            onClick={() => {
              handleBtnInputArray('axisleft'); // use a separate key for left eye
              
              setIsOncularExaminatonBtn(isOncularExaminatonBtn ? false : true);
            }}
            onChange={(e) => handleIop('LeftEye', 'axis', e.target.value)}
          />{' '}
        </Col>
        <Col className="mt-3" style={{ textAlign: "center" }}>
          <Form.Control
            size="sm"
            
            value={ocularExamination?.LeftEye?.va || ' '}
            

            onClick={() => {
              handleBtnInputArray('valeft'); // use a separate key for left eye
              
              setIsOncularExaminatonBtn(isOncularExaminatonBtn ? false : true);
            }}
            defaultValue={ocularExamination?.LeftEye?.va}
            onChange={(e) => handleIop('LeftEye', 'va', e.target.value)}
          />{' '}
        </Col>
      </Row>
      <Row>
      {isOncularExaminatonBtn && (fieldName === 'sphereLeft' || fieldName === 'sphereLeftNeg')&&(
                  <Row className="justify-content-center mt-2">
                   
                    <Col md={12} className="d-flex justify-content-center flex-column align-items-center">
                  <div className="mb-1"style={{marginRight: "21.25rem"}}>
                          <Button
                            size="sm"
                            variant={btnSign === 'positive' ? 'primary' : 'outline-primary'}
                            className="me-2"
                            onClick={() => {
                              setBtnSign('positive');
                              handleBtnInputArray('sphereLeft'); // positive values
                            }}
                          >
                            +
                          </Button>

                          <Button
                            size="sm"
                            variant={btnSign === 'negative' ? 'danger' : 'outline-danger'}
                            onClick={() => {
                              setBtnSign('negative');
                              handleBtnInputArray('sphereLeftNeg'); // negative values
                            }}
                          >
                            −
                          </Button>
                  </div>
                      <OncularExaminatonBtn
                        rowName="LeftEye"  
                        fieldName="sphere"         
                        btnInputArray={btnInputArray}
                        // onClickAction={handleGeneralExamination}
                        onClickAction={handleOcularExamination}
                              
                      />
                    </Col>
                  </Row>
                )}  
               {isOncularExaminatonBtn && (fieldName === 'cylleft' || fieldName === 'cylleftNeg')&&(
                  <Row className="justify-content-center mt-2">
                    
                    <Col md={12} className="d-flex justify-content-center flex-column align-items-center">
                  <div className="mb-1">
                          <Button
                            size="sm"
                            variant={btnSign === 'positive' ? 'primary' : 'outline-primary'}
                            className="me-2"
                            onClick={() => {
                              setBtnSign('positive');
                              handleBtnInputArray('cylleft'); // positive values
                            }}
                          >
                            +
                          </Button>

                          <Button
                            size="sm"
                            variant={btnSign === 'negative' ? 'danger' : 'outline-danger'}
                            onClick={() => {
                              setBtnSign('negative');
                              handleBtnInputArray('cylleftNeg'); // negative values
                            }}
                          >
                            −
                          </Button>
                  </div>
                      <OncularExaminatonBtn
                        rowName="LeftEye"  
                        fieldName="cyl"         
                        btnInputArray={btnInputArray}
                        // onClickAction={handleGeneralExamination}
                        onClickAction={handleOcularExamination}
                              
                      />
                    </Col>
                  </Row>
                )}
           <Col className="mt-2" style={{ textAlign: "center" }}></Col>      
           {isOncularExaminatonBtn && fieldName === 'axisleft'&&(
                              <Row className="justify-content-center mt-2">
                                <Col md={3}></Col>
                                <Col md={12} className="d-flex justify-content-center flex-column align-items-center">
 
                                  <OncularExaminatonBtn
                                    rowName="LeftEye"  
                                    fieldName="axis"         
                                    btnInputArray={btnInputArray}
                                    // onClickAction={handleGeneralExamination}
                                    onClickAction={handleOcularExamination}
                                          
                                  />
                                </Col>
                              </Row>
                            )}


           {isOncularExaminatonBtn && fieldName === 'valeft'&&(
                              <Row className="justify-content-end mt-2">
                                
                                <Col md={16} className="d-flex justify-content-center flex-column align-items-center">
 
                                  <OncularExaminatonBtn
                                    rowName="LeftEye"  
                                    fieldName="va"         
                                    btnInputArray={btnInputArray}
                                    // onClickAction={handleGeneralExamination}
                                    onClickAction={handleOcularExamination}
                                          
                                  />
                                </Col>
                              </Row>
                            )}

      </Row>


      

      
      <Row className="mt-3">
        <Col className="font-weight-bold">ADD:</Col>
        <Col className="pt-1">
          <Form.Control
            size="sm"
            
            
            value={ocularExamination?.ADD?.add || ' '}
            

            onClick={() => {
              handleBtnInputArray('add'); // use a separate key for left eye
              setBtnSign('positive');
              setIsOncularExaminatonBtn(isOncularExaminatonBtn ? false : true);
            }}
            onChange={(e) => handleIop('ADD', 'add', e.target.value)}
          />{' '}
        </Col>
        <Col className="pt-1"></Col>        
        <Col className="font-weight-bold">IPD:</Col>
        <Col className="pt-1">
          <Form.Control
            size="sm"
            
            defaultValue={ocularExamination?.IPD?.ipd}
            onChange={(e) => handleIop('IPD', 'ipd', e.target.value)}
          />{' '}
        </Col>
        <Col className="pt-1"></Col>
      </Row>

      <Row className="mt-3">
      {isOncularExaminatonBtn && fieldName === 'add'&&(
                              <Row className="justify-content-end mt-2">
                                
                                <Col md={16} className="d-flex justify-content-center flex-column align-items-center">
 
                                  <OncularExaminatonBtn
                                    rowName="ADD"  
                                    fieldName="add"         
                                    btnInputArray={btnInputArray}
                                    // onClickAction={handleGeneralExamination}
                                    onClickAction={handleOcularExamination}
                                          
                                  />
                                </Col>
                              </Row>
                            )}
      </Row>


      <Row className="mt-3">
        <Col className="font-weight-bold">IOP(Right):</Col>
        <Col className="pl-0">
          <Form.Control
            size="sm"
            type="number"
            defaultValue={ocularExamination?.iop?.high}
            onChange={(e) => handleIop('iop', 'high', e.target.value)}
          />{' '}
        </Col>
        <Col className="pt-1">mmHg</Col>
        <Col className="font-weight-bold">IOP(Left):</Col>
        <Col>
          <Form.Control
            size="sm"
            type="number"
            defaultValue={ocularExamination?.iop?.low}
            onChange={(e) => handleIop('iop', 'low', e.target.value)}
          />{' '}
        </Col>
        <Col className="pt-1">mmHg</Col>
      </Row>
      <Row className="pt-4">
        <Col className="font-weight-bold">Color Vision:</Col>
        <Col className="pl-4">
          <Form.Check
            type={`checkbox`}
            id={`normal`}
            name="normal"
            label={`Normal`}
            checked={ocularExamination.colorVision.normal === true}
            onChange={(e) =>
              handleOcularExamination('colorVision', 'normal', e.target.checked)
            }
          />
        </Col>
        <Col>
          <Form.Check
            type={`checkbox`}
            id={`deficit`}
            name="deficit"
            label={`Deficit`}
            checked={ocularExamination.colorVision.deficit === true}
            onChange={(e) =>
              handleOcularExamination(
                'colorVision',
                'deficit',
                e.target.checked,
              )
            }
          />
        </Col>
        <Col>
          <Form.Check
            type={`checkbox`}
            id={`red`}
            name="red"
            label={`Red`}
            checked={ocularExamination.colorVision.red === true}
            onChange={(e) =>
              handleOcularExamination('colorVision', 'red', e.target.checked)
            }
          />
        </Col>
        <Col>
          <Form.Check
            type={`checkbox`}
            id={`blue`}
            name="blue"
            label={`Blue`}
            checked={ocularExamination.colorVision.blue === true}
            onChange={(e) =>
              handleOcularExamination('colorVision', 'blue', e.target.checked)
            }
          />
        </Col>
        <Col>
          <Form.Check
            type={`checkbox`}
            id={`green`}
            name="green"
            label={`Green`}
            checked={ocularExamination.colorVision.green === true}
            onChange={(e) =>
              handleOcularExamination('colorVision', 'green', e.target.checked)
            }
          />
        </Col>
      </Row>
      <Row className="pt-3 font-weight-bold">
        <Col md={3}>
          <b>Ocular Motility:</b>
        </Col>
        <Col md={4} style={{ paddingLeft: '52px' }}>
          OD:
        </Col>
        <Col md={4} style={{ paddingLeft: '52px' }}>
          OS:
        </Col>
      </Row>
      <Row className="pt-1">
        <Col md={2}></Col>
        <Col>
          <div className="od-os">
            <span
              style={{ position: 'absolute', top: '5px', left: '23px' }}
              className="cursor-pointer"
              onClick={() =>
                handleGraphicalExamination(
                  'ocularMotility',
                  'od',
                  'sixth',
                  ocularExamination.ocularMotility.od.sixth,
                )
              }
            >
              {ocularExamination.ocularMotility.od.sixth
                ? parse(checkedIcon)
                : parse(crossIcon)}
            </span>
            <span
              style={{ position: 'absolute', top: '5px', left: '110px' }}
              className="cursor-pointer"
              onClick={() =>
                handleGraphicalExamination(
                  'ocularMotility',
                  'od',
                  'first',
                  ocularExamination.ocularMotility.od.first,
                )
              }
            >
              {ocularExamination.ocularMotility.od.first
                ? parse(checkedIcon)
                : parse(crossIcon)}
            </span>
            <span
              style={{ position: 'absolute', top: '50px', left: '2px' }}
              className="cursor-pointer"
              onClick={() =>
                handleGraphicalExamination(
                  'ocularMotility',
                  'od',
                  'fifth',
                  ocularExamination.ocularMotility.od.fifth,
                )
              }
            >
              {ocularExamination.ocularMotility.od.fifth
                ? parse(checkedIcon)
                : parse(crossIcon)}
            </span>
            <span
              style={{ position: 'absolute', bottom: '12px', left: '112px' }}
              className="cursor-pointer"
              onClick={() =>
                handleGraphicalExamination(
                  'ocularMotility',
                  'od',
                  'third',
                  ocularExamination.ocularMotility.od.third,
                )
              }
            >
              {ocularExamination.ocularMotility.od.third
                ? parse(checkedIcon)
                : parse(crossIcon)}
            </span>
            <img src={ocularMotility} height="120" width="120"></img>
            <span
              style={{ position: 'absolute', bottom: '11px', left: '23px' }}
              className="cursor-pointer"
              onClick={() =>
                handleGraphicalExamination(
                  'ocularMotility',
                  'od',
                  'fourth',
                  ocularExamination.ocularMotility.od.fourth,
                )
              }
            >
              {ocularExamination.ocularMotility.od.fourth
                ? parse(checkedIcon)
                : parse(crossIcon)}
            </span>
            <span
              style={{ position: 'absolute', left: '130px', bottom: '59px' }}
              className="cursor-pointer"
              onClick={() =>
                handleGraphicalExamination(
                  'ocularMotility',
                  'od',
                  'second',
                  ocularExamination.ocularMotility.od.second,
                )
              }
            >
              {ocularExamination.ocularMotility.od.second
                ? parse(checkedIcon)
                : parse(crossIcon)}
            </span>
          </div>
        </Col>
        <Col>
          <div className="od-os">
            <span
              style={{ position: 'absolute', top: '5px', left: '23px' }}
              className="cursor-pointer"
              onClick={() =>
                handleGraphicalExamination(
                  'ocularMotility',
                  'os',
                  'sixth',
                  ocularExamination.ocularMotility.os.sixth,
                )
              }
            >
              {ocularExamination.ocularMotility.os.sixth
                ? parse(checkedIcon)
                : parse(crossIcon)}
            </span>
            <span
              style={{ position: 'absolute', top: '5px', left: '110px' }}
              className="cursor-pointer"
              onClick={() =>
                handleGraphicalExamination(
                  'ocularMotility',
                  'os',
                  'first',
                  ocularExamination.ocularMotility.os.first,
                )
              }
            >
              {ocularExamination.ocularMotility.os.first
                ? parse(checkedIcon)
                : parse(crossIcon)}
            </span>
            <span
              style={{ position: 'absolute', top: '50px', left: '2px' }}
              className="cursor-pointer"
              onClick={() =>
                handleGraphicalExamination(
                  'ocularMotility',
                  'os',
                  'fifth',
                  ocularExamination.ocularMotility.os.fifth,
                )
              }
            >
              {ocularExamination.ocularMotility.os.fifth
                ? parse(checkedIcon)
                : parse(crossIcon)}
            </span>
            <span
              style={{ position: 'absolute', bottom: '12px', left: '112px' }}
              className="cursor-pointer"
              onClick={() =>
                handleGraphicalExamination(
                  'ocularMotility',
                  'os',
                  'third',
                  ocularExamination.ocularMotility.os.third,
                )
              }
            >
              {ocularExamination.ocularMotility.os.third
                ? parse(checkedIcon)
                : parse(crossIcon)}
            </span>
            <img src={ocularMotility} height="120" width="120"></img>
            <span
              style={{ position: 'absolute', left: '23px', bottom: '11px' }}
              className="cursor-pointer"
              onClick={() =>
                handleGraphicalExamination(
                  'ocularMotility',
                  'os',
                  'fourth',
                  ocularExamination.ocularMotility.os.fourth,
                )
              }
            >
              {ocularExamination.ocularMotility.os.fourth
                ? parse(checkedIcon)
                : parse(crossIcon)}
            </span>
            <span
              style={{ position: 'absolute', left: '130px', bottom: '59px' }}
              className="cursor-pointer"
              onClick={() =>
                handleGraphicalExamination(
                  'ocularMotility',
                  'os',
                  'second',
                  ocularExamination.ocularMotility.os.second,
                )
              }
            >
              {ocularExamination.ocularMotility.os.second
                ? parse(checkedIcon)
                : parse(crossIcon)}
            </span>
          </div>
        </Col>
        <Col md={2}></Col>
      </Row>
      <Row className="">
        <Col md="3">
          <b>Angle Evaluation:</b>
        </Col>
      </Row>
      <Row className="pt-1">
        <Col md={1}></Col>
        <Col>
          <div className="angle-evaluation">
            <span
              className="angle-ev-btn"
              style={{ top: 0 }}
              onClick={() =>
                angleEvaluation('angleEvaluationBefore', 'od', 'first')
              }
            >
              {ocularExamination.angleEvaluationBefore.od.first || 'Select'}{' '}
              <i className="fas fa-angle-down pl-1"></i>
            </span>
            {isAngleBtn.rowName === 'angleEvaluationBefore' &&
              isAngleBtn.type === 'od' &&
              isAngleBtn.indexName === 'first' && (
                <CommonButtons
                  unitArray={angleButtonArray}
                  clickAction={handleAngleEvaluation}
                  rowName="angleEvaluationBefore"
                  colName="od"
                  indexName="first"
                />
              )}
            <span
              className="angle-ev-btn"
              style={{ top: '54px', right: '0px' }}
              onClick={() =>
                angleEvaluation('angleEvaluationBefore', 'od', 'second')
              }
            >
              {ocularExamination.angleEvaluationBefore.od.second || 'Select'}{' '}
              <i className="fas fa-angle-down pl-1"></i>
            </span>
            {isAngleBtn.rowName === 'angleEvaluationBefore' &&
              isAngleBtn.type === 'od' &&
              isAngleBtn.indexName === 'second' && (
                <CommonButtons
                  unitArray={angleButtonArray}
                  clickAction={handleAngleEvaluation}
                  rowName="angleEvaluationBefore"
                  colName="od"
                  indexName="second"
                />
              )}
            <img src={angelEvaluation} height={70} width={90} />
            <span
              className="angle-ev-btn"
              style={{ bottom: 0 }}
              onClick={() =>
                angleEvaluation('angleEvaluationBefore', 'od', 'third')
              }
            >
              {ocularExamination.angleEvaluationBefore.od.third || 'Select'}{' '}
              <i className="fas fa-angle-down pl-1"></i>
            </span>
            {isAngleBtn.rowName === 'angleEvaluationBefore' &&
              isAngleBtn.type === 'od' &&
              isAngleBtn.indexName === 'third' && (
                <CommonButtons
                  unitArray={angleButtonArray}
                  clickAction={handleAngleEvaluation}
                  rowName="angleEvaluationBefore"
                  colName="od"
                  indexName="third"
                />
              )}
            <span
              className="angle-ev-btn"
              style={{ top: '54px', left: '0px' }}
              onClick={() =>
                angleEvaluation('angleEvaluationBefore', 'od', 'fourth')
              }
            >
              {ocularExamination.angleEvaluationBefore.od.fourth || 'Select'}{' '}
              <i className="fas fa-angle-down pl-1"></i>
            </span>
            {isAngleBtn.rowName === 'angleEvaluationBefore' &&
              isAngleBtn.type === 'od' &&
              isAngleBtn.indexName === 'fourth' && (
                <CommonButtons
                  unitArray={angleButtonArray}
                  clickAction={handleAngleEvaluation}
                  rowName="angleEvaluationBefore"
                  colName="od"
                  indexName="fourth"
                />
              )}
          </div>
        </Col>
        <Col className="pr-4">
          <div className="angle-evaluation">
            <span
              className="angle-ev-btn"
              style={{ top: 0 }}
              onClick={() =>
                angleEvaluation('angleEvaluationBefore', 'os', 'first')
              }
            >
              {ocularExamination.angleEvaluationBefore.os.first || 'Select'}{' '}
              <i className="fas fa-angle-down pl-1"></i>
            </span>
            {isAngleBtn.rowName === 'angleEvaluationBefore' &&
              isAngleBtn.type === 'os' &&
              isAngleBtn.indexName === 'first' && (
                <CommonButtons
                  unitArray={angleButtonArray}
                  clickAction={handleAngleEvaluation}
                  rowName="angleEvaluationBefore"
                  colName="os"
                  indexName="first"
                />
              )}
            <span
              className="angle-ev-btn"
              style={{ top: '54px', right: '0px' }}
              onClick={() =>
                angleEvaluation('angleEvaluationBefore', 'os', 'second')
              }
            >
              {ocularExamination.angleEvaluationBefore.os.second || 'Select'}{' '}
              <i className="fas fa-angle-down pl-1"></i>
            </span>
            {isAngleBtn.rowName === 'angleEvaluationBefore' &&
              isAngleBtn.type === 'os' &&
              isAngleBtn.indexName === 'second' && (
                <CommonButtons
                  unitArray={angleButtonArray}
                  clickAction={handleAngleEvaluation}
                  rowName="angleEvaluationBefore"
                  colName="os"
                  indexName="second"
                />
              )}
            <img src={angelEvaluation} height={70} width={90} />
            <span
              className="angle-ev-btn"
              style={{ bottom: 0 }}
              onClick={() =>
                angleEvaluation('angleEvaluationBefore', 'os', 'third')
              }
            >
              {ocularExamination.angleEvaluationBefore.os.third || 'Select'}{' '}
              <i className="fas fa-angle-down pl-1"></i>
            </span>
            {isAngleBtn.rowName === 'angleEvaluationBefore' &&
              isAngleBtn.type === 'os' &&
              isAngleBtn.indexName === 'third' && (
                <CommonButtons
                  unitArray={angleButtonArray}
                  clickAction={handleAngleEvaluation}
                  rowName="angleEvaluationBefore"
                  colName="os"
                  indexName="third"
                />
              )}
            <span
              className="angle-ev-btn"
              style={{ top: '54px', left: '0px' }}
              onClick={() =>
                angleEvaluation('angleEvaluationBefore', 'os', 'fourth')
              }
            >
              {ocularExamination.angleEvaluationBefore.os.fourth || 'Select'}{' '}
              <i className="fas fa-angle-down pl-1"></i>
            </span>
            {isAngleBtn.rowName === 'angleEvaluationBefore' &&
              isAngleBtn.type === 'os' &&
              isAngleBtn.indexName === 'fourth' && (
                <CommonButtons
                  unitArray={angleButtonArray}
                  clickAction={handleAngleEvaluation}
                  rowName="angleEvaluationBefore"
                  colName="os"
                  indexName="fourth"
                />
              )}
          </div>
        </Col>
      </Row>
      <Row className="mt-4 mb-3">
        <Col md={1}></Col>
        <Col>
          <b>After Indentation:</b>
        </Col>
      </Row>
      <Row className="mb-3">
        <Col md={1}></Col>
        <Col>
          <div className="angle-evaluation">
            <span
              className="angle-ev-btn"
              style={{ top: 0 }}
              onClick={() =>
                angleEvaluation('angleEvaluationAfter', 'od', 'first')
              }
            >
              {ocularExamination.angleEvaluationAfter.od.first || 'Select'}{' '}
              <i className="fas fa-angle-down pl-1"></i>
            </span>
            {isAngleBtn.rowName === 'angleEvaluationAfter' &&
              isAngleBtn.type === 'od' &&
              isAngleBtn.indexName === 'first' && (
                <CommonButtons
                  unitArray={angleButtonArray}
                  clickAction={handleAngleEvaluation}
                  rowName="angleEvaluationAfter"
                  colName="od"
                  indexName="first"
                />
              )}
            <span
              className="angle-ev-btn"
              style={{ top: '54px', right: '0px' }}
              onClick={() =>
                angleEvaluation('angleEvaluationAfter', 'od', 'second')
              }
            >
              {ocularExamination.angleEvaluationAfter.od.second || 'Select'}{' '}
              <i className="fas fa-angle-down pl-1"></i>
            </span>
            {isAngleBtn.rowName === 'angleEvaluationAfter' &&
              isAngleBtn.type === 'od' &&
              isAngleBtn.indexName === 'second' && (
                <CommonButtons
                  unitArray={angleButtonArray}
                  clickAction={handleAngleEvaluation}
                  rowName="angleEvaluationAfter"
                  colName="od"
                  indexName="second"
                />
              )}
            <img src={angelEvaluation} height={70} width={90} />
            <span
              className="angle-ev-btn"
              style={{ bottom: 0 }}
              onClick={() =>
                angleEvaluation('angleEvaluationAfter', 'od', 'third')
              }
            >
              {ocularExamination.angleEvaluationAfter.od.third || 'Select'}{' '}
              <i className="fas fa-angle-down pl-1"></i>
            </span>
            {isAngleBtn.rowName === 'angleEvaluationAfter' &&
              isAngleBtn.type === 'od' &&
              isAngleBtn.indexName === 'third' && (
                <CommonButtons
                  unitArray={angleButtonArray}
                  clickAction={handleAngleEvaluation}
                  rowName="angleEvaluationAfter"
                  colName="od"
                  indexName="third"
                />
              )}
            <span
              className="angle-ev-btn"
              style={{ top: '54px', left: '0px' }}
              onClick={() =>
                angleEvaluation('angleEvaluationAfter', 'od', 'fourth')
              }
            >
              {ocularExamination.angleEvaluationAfter.od.fourth || 'Select'}{' '}
              <i className="fas fa-angle-down pl-1"></i>
            </span>
            {isAngleBtn.rowName === 'angleEvaluationAfter' &&
              isAngleBtn.type === 'od' &&
              isAngleBtn.indexName === 'fourth' && (
                <CommonButtons
                  unitArray={angleButtonArray}
                  clickAction={handleAngleEvaluation}
                  rowName="angleEvaluationAfter"
                  colName="od"
                  indexName="fourth"
                />
              )}
          </div>
        </Col>
        <Col className="pr-4">
          <div className="angle-evaluation">
            <span
              className="angle-ev-btn"
              style={{ top: 0 }}
              onClick={() =>
                angleEvaluation('angleEvaluationAfter', 'os', 'first')
              }
            >
              {ocularExamination.angleEvaluationAfter.os.first || 'Select'}{' '}
              <i className="fas fa-angle-down pl-1"></i>
            </span>
            {isAngleBtn.rowName === 'angleEvaluationAfter' &&
              isAngleBtn.type === 'os' &&
              isAngleBtn.indexName === 'first' && (
                <CommonButtons
                  unitArray={angleButtonArray}
                  clickAction={handleAngleEvaluation}
                  rowName="angleEvaluationAfter"
                  colName="os"
                  indexName="first"
                />
              )}
            <span
              className="angle-ev-btn"
              style={{ top: '54px', right: '0px' }}
              onClick={() =>
                angleEvaluation('angleEvaluationAfter', 'os', 'second')
              }
            >
              {ocularExamination.angleEvaluationAfter.os.second || 'Select'}{' '}
              <i className="fas fa-angle-down pl-1"></i>
            </span>
            {isAngleBtn.rowName === 'angleEvaluationAfter' &&
              isAngleBtn.type === 'os' &&
              isAngleBtn.indexName === 'second' && (
                <CommonButtons
                  unitArray={angleButtonArray}
                  clickAction={handleAngleEvaluation}
                  rowName="angleEvaluationAfter"
                  colName="os"
                  indexName="second"
                />
              )}
            <img src={angelEvaluation} height={70} width={90} />
            <span
              className="angle-ev-btn"
              style={{ bottom: 0 }}
              onClick={() =>
                angleEvaluation('angleEvaluationAfter', 'os', 'third')
              }
            >
              {ocularExamination.angleEvaluationAfter.os.third || 'Select'}{' '}
              <i className="fas fa-angle-down pl-1"></i>
            </span>
            {isAngleBtn.rowName === 'angleEvaluationAfter' &&
              isAngleBtn.type === 'os' &&
              isAngleBtn.indexName === 'third' && (
                <CommonButtons
                  unitArray={angleButtonArray}
                  clickAction={handleAngleEvaluation}
                  rowName="angleEvaluationAfter"
                  colName="os"
                  indexName="third"
                />
              )}
            <span
              className="angle-ev-btn"
              style={{ top: '54px', left: '0px' }}
              onClick={() =>
                angleEvaluation('angleEvaluationAfter', 'os', 'fourth')
              }
            >
              {ocularExamination.angleEvaluationAfter.os.fourth || 'Select'}{' '}
              <i className="fas fa-angle-down pl-1"></i>
            </span>
            {isAngleBtn.rowName === 'angleEvaluationAfter' &&
              isAngleBtn.type === 'os' &&
              isAngleBtn.indexName === 'fourth' && (
                <CommonButtons
                  unitArray={angleButtonArray}
                  clickAction={handleAngleEvaluation}
                  rowName="angleEvaluationAfter"
                  colName="os"
                  indexName="fourth"
                />
              )}
          </div>
        </Col>
      </Row>
    </>
  );
};
export default memo(OcularExamination);
